import iconify from '~/helpers/iconify';
import { aliases } from 'vuetify/iconsets/mdi-svg';

const icons = {
  sets: {
    mdi: iconify('mdi'),
    ic: iconify('ic'),
    logos: iconify('logos'),
    uil: iconify('uil'),
    clarity: iconify('clarity'),
    bx: iconify('bx'),
    'pepicons-print': iconify('pepicons-print')
  },
  aliases
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vuetify:before-create', ({ vuetifyOptions }) => {
    vuetifyOptions.icons = icons;
  });
});